window.VH = window.VH === undefined ? {} : window.VH;
let sendFile = function (answer) {
  $('#ajaxModal').modal('hide');

  let anchor = document.createElement('a');

  anchor.download = answer.filename;
  anchor.href = `data:${answer.mime};base64,${answer.content}`;
  anchor.target = '_blank';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

VH.AjaxModalForm = {
  init: function init() {
    $('#ajaxModal').off('submit.ajaxModalForm', '.ajaxModalForm').on('submit.ajaxModalForm', '.ajaxModalForm', function (e) {
      e.preventDefault();
      let form = $(this);
      const loadingLabel = form.attr('data-submit-label');
      if (loadingLabel && form.data('submitting')) {
        return false;
      }
      const payload = form.serialize();
      const submit = form.find(':submit');
      const originalLabel = submit.html();
      const modal = form.closest('.modal');
      const controls = modal.find('button:enabled');
      if (loadingLabel) {
        form.data('submitting', true).attr('aria-busy', 'true');
        form.find('.ajax-submit-error').remove();
        controls.prop('disabled', true);
        submit.empty().append('<i class="fas fa-spinner fa-spin" aria-hidden="true"></i> ')
          .append($('<span>').text(loadingLabel));
        modal.on('hide.bs.modal.ajaxSubmit', (event) => event.preventDefault());
      }

      $.post(
        form.attr('action'),
        payload,
        function (answer) {
          if (typeof answer === 'string' && answer.trim() === 'OK') {
            form.closest('.modal-body').html('Ok');
            location.reload();
          }
          else {
            switch (typeof answer) {
              case 'string':
                form.closest('.modal-body').html(answer);
                break;

              case 'object':
                if ('undefined' !== typeof answer.mime) {
                  sendFile(answer);
                }
                break;

              default:
                break;
            }
          }
        },
      ).fail(function () {
        if (loadingLabel) {
          $('<div class="alert alert-danger ajax-submit-error" role="alert">')
            .text(form.attr('data-submit-error'))
            .prependTo(form);
        }
      }).always(function () {
        if (loadingLabel) {
          form.data('submitting', false).removeAttr('aria-busy');
          controls.prop('disabled', false);
          submit.html(originalLabel);
          modal.off('hide.bs.modal.ajaxSubmit');
        }
      });

      return false;
    });
  },
};
